define('views/modals/filter/content',['require','underscore','lib/utils','views/base/view','text!templates/modals/filter/content.ejs'],function(require) {
    'use strict';

    var     _ = require('underscore'),
        utils = require('lib/utils'),
        View = require('views/base/view'),
        template = require('text!templates/modals/filter/content.ejs');

    var FilterModalContentView = View.extend({
        autoRender: true,
        className: 'filter-modal-content',
        region: 'modal-content',
        template: template,
        listen: {
            'afterLoad model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this._render = _.debounce(this.render);
        },
        update: function() {
            var model = this.model;
            var $el = this.$('input[type=hidden]');

            $el.each(function() {
                var $this = $(this);

                var fieldName = $this.data('fieldName');

                $this.select2({
                    multiple: true,
                    data: model.getData(fieldName),
                    formatResultCssClass: function(item) {
                        return 'filter-item ' + (item._disabled ? 'filter-item-disabled' : '');
                    }
                });
                $this.val(model.getSelected(fieldName)).trigger('change');
            });
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            var _this = this;
            var model = this.model;
            var $el = this.$('input[type=hidden]');

            this.update();

            $el.on('change', function() {
                var $this = $(this);
                var fieldName = $this.data('fieldName');
                model.select(fieldName, ($this.val() || '').replace(/^,/, '').split(','));
                // setTimeout(function() {
                //     _this.update();
                // }, 300);
            });

            setTimeout(function() {
                _this.initRangeControls();
            }, 10);


            // BOOLEAN field

            var $elCh = this.$('input[type=checkbox]');

            var changeBoolean = function(){
                var $this = $(this);
                var fieldName = $this.data('fieldName');
                model.select(fieldName, $this.is(':checked') + '');
                setTimeout(function() {
                    _this.update();
                }, 300);
            };

            $elCh.on('change', changeBoolean);

            setTimeout(function() {
                $elCh.each(changeBoolean);
            }, 10);
        },
        afterLoad: function() {
            this.render();
        },

        initRangeControls: function() {
            var $el = this.$('.rangebar');
            var model = this.model;

            $el.each(function() {
                var $rb = $(this);

                var $ls = $rb.find('.rangebar-left-slider');
                var $rs = $rb.find('.rangebar-right-slider');

                var fieldName = $rb.data('fieldName');

                var field = model.getField(fieldName);

                var innerWidth = $rb.width() - 2 -2 - $ls.width();
                var range = field.rangeMax - field.rangeMin;

                var koefA, koefB;
                if (innerWidth) {
                    koefA = range / (innerWidth - $ls.width() -2);
                } else {
                    koefA = 0;
                }

                if (range) {
                    koefB = (innerWidth  - $ls.width() -2) / range;
                } else {
                    koefB = 0;
                }

                function valueToPos(val) {
                    return koefB * (val - field.rangeMin) + 2;
                }

                function posToValue(left) {
                    return field.rangeMin + koefA * (left -2);
                }

                var lsDown = false, rsDown = false;

                var sel = field.selected[0] || field.rangeMin;

                var lsp = valueToPos(sel);
                $ls.css('left',  lsp + 'px');
                $ls.text(utils.money(sel));

                field.leftValue = sel;
                field.leftPos = lsp;


                sel = field.selected[1] || field.rangeMax;

                var rsp = valueToPos(sel) + $ls.width();
                $rs.css('left', rsp + 'px');
                $rs.text(utils.money(sel));

                field.rightValue = sel;
                field.rightPos = rsp;

                var onMouseMove = function(ev) {
                    if (lsDown || rsDown) {
                        var value, pos;

                        if (lsDown) {
                            pos = Math.min(Math.max(2, lsDown.left + ev.clientX - lsDown.clientX + 2), $rs.position().left - $ls.width());
                            $ls.css('left', pos + 'px');

                            value = posToValue(pos);
                            $ls.text(utils.money(value));

                            field.leftValue = value;
                            field.leftPos = pos;
                        }

                        if (rsDown) {
                            pos = Math.max(Math.min(innerWidth, rsDown.left + ev.clientX - rsDown.clientX + 2), $ls.position().left + $ls.width());
                            $rs.css('left', pos + 'px');

                            value = posToValue(pos - $ls.width());
                            $rs.text(utils.money(value));

                            field.rightValue = value;
                            field.rightPos = pos;
                        }
                    }
                };

                var onMouseUp = function() {

                    if (lsDown || rsDown) {
                        lsDown = false;
                        rsDown = false;

                        // updateFilter();
                        model.select(fieldName, [field.leftValue, field.rightValue]);
                    }

                    $(window).off('mousemove', onMouseMove);
                };

                var bindWindow = function() {
                    $(window).one('mouseup', onMouseUp);
                    $(window).on('mousemove', onMouseMove);
                };

                $ls.on('mousedown', function(ev) {
                    if (ev.button !== 0 ) { lsDown = false; return; }
                    lsDown = { clientX: ev.clientX, left: $ls.position().left };
                    bindWindow();
                });

                $rs.on('mousedown', function(ev) {
                    if (ev.button !== 0 ) { rsDown = false; return; }
                    rsDown = { clientX: ev.clientX, left: $rs.position().left };
                    bindWindow();
                });
            });

        }
    });

    return FilterModalContentView;
});

